import type { CustomizationItem } from '../../types';

export const createDefaultCustomizationItems = (menuIds: string[]): CustomizationItem[] =>
	menuIds.map((menuId) => ({ menuId, visible: true }));
